import {
  Component,
  AfterViewInit,
  ViewChildren,
  QueryList,
  ComponentFactoryResolver,
  OnDestroy,
  OnInit
} from '@angular/core';

import { ModalContainerDirective } from './modal-container.directive';
import { DynamicModalService } from './dynamic-modal.service';
import { ModalItem } from './modal-item';

declare var $: any;


@Component({
  selector: 'dynamic-modal',
  templateUrl: './dynamic-modals.component.html',
  styleUrls: ['./dynamic-modals.component.scss']
})
export class DynamicModalComponent implements AfterViewInit, OnDestroy, OnInit  {
    modalItems: ModalItem[];
    currentAddIndex = -1;
    @ViewChildren(ModalContainerDirective) modalHost: QueryList<ModalContainerDirective>;
    subscription: any;
    interval: any;
    noOfDiaologs = 0;

    constructor(
        private dynamicModalService: DynamicModalService,
        private componentFactoryResolver: ComponentFactoryResolver
    ) {
        this.modalItems = [];
    }

    ngAfterViewInit() {
        this.modalHost.changes
            .subscribe(() => {
              window.setTimeout(() => {
                    if (this.noOfDiaologs == this.modalItems.length) {
                        this.openDialogCurrent();
                    } else {
                        this.noOfDiaologs = this.modalItems.length;
                    }
                }, 200);
            });
    }

    ngOnInit() {
        this.dynamicModalService.getModals().subscribe((modalT: ModalItem) => {
            if (modalT == null) {
                this.close();
                return;
            }
            if (!modalT.widthOfDialog) {
                modalT.widthOfDialog = '100%';
            } else if (modalT.widthOfDialog.indexOf('%') < 0 && modalT.widthOfDialog.indexOf('px') < 0) {
                modalT.widthOfDialog += 'px';
            }

            if (!modalT.height) {
                modalT.displayStyle = 'table';
            } else {
                modalT.displayStyle = '';
                if (modalT.height.indexOf('%') < 0 && modalT.height.indexOf('px') < 0) {
                    modalT.height += 'px';
                }
                if (window.innerHeight <= 768) {
                    modalT.top = '-150px';
                }
            }
            this.modalItems.push(modalT);
            this.noOfDiaologs = this.modalItems.length;
        });

        this.dynamicModalService.subjectToModifyModaltext.subscribe((modalT: any) => {
            const filterIndex = this.modalItems.findIndex((d) => d.formName == modalT.formName);
            if (filterIndex >= 0) {
                this.modalItems[filterIndex].titleOfDialog = modalT.titleOfDialog;
            }
        });
        // this._dynamicModalService.subjectOnClose.subscribe((data: any) => {
        //     this.close();
        // });
    }

    ngOnDestroy() { }

    removeAlert(modalT: ModalItem) {
        this.modalItems = this.modalItems.filter(x => x !== modalT);
    }

    close() {
        const viewC = this.modalHost.last;
        viewC.viewContainerRef.clear();
        const modalDialogId = '#dynamicModal' + (this.modalItems.length - 1);
        const modal = this.modalItems.pop();
        if (modal.componentRef.onModalClose) {
          modal.componentRef.onModalClose();
        }
        $(modalDialogId).modal('hide');
    }

    openDialogCurrent() {
        const modalDialogId = '#dynamicModal' + (this.modalItems.length - 1);
        $(modalDialogId).modal({
            keyboard: false,
            backdrop: 'static',
        });
      this.loadCurrentComponent();
    }

    loadCurrentComponent() {
        this.currentAddIndex = (this.currentAddIndex + 1) % this.modalItems.length;
        const index = this.modalHost.length - 1;

        const viewC = this.modalHost.last;
        const adItem = this.modalItems[index];
        if (!adItem) {
            return;
        }

        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(adItem.component);
        const viewContainerRef = viewC.viewContainerRef;
        viewContainerRef.clear();

        const componentRef = viewContainerRef.createComponent(componentFactory);
        const componentInstance = <any>componentRef.instance;

        componentInstance.subjectOnClose = adItem.subjectOnClose;
        componentInstance.modalData = adItem.data;

        this.modalItems[index].componentRef = componentInstance;

    }

    closeModalDialog() {
      console.log('CLOSE MODAL');

      const modalDialogId = this.modalItems.length - 1;
        if (modalDialogId >= 0) {
            if (this.modalItems[modalDialogId].componentRef.subjectOnClose && this.modalItems[modalDialogId].componentRef.subjectOnClose.observers.length > 0) {
                this.modalItems[modalDialogId].componentRef.subjectOnClose.next(null);
                this.close();
                return true;
            }
        }
    }
}
